var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "mentor_request career"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = { class: "inner" };
const _hoisted_5 = {
    key: 0,
    class: "err"
};
const _hoisted_6 = {
    key: 0,
    class: "err"
};
const _hoisted_7 = { class: "job_box" };
const _hoisted_8 = { class: "bt_right" };
const _hoisted_9 = ["onClick"];
const _hoisted_10 = ["onClick"];
const _hoisted_11 = { class: "l1" };
const _hoisted_12 = { class: "l1" };
const _hoisted_13 = { class: "l2" };
const _hoisted_14 = { class: "l2" };
const _hoisted_15 = {
    class: "l1",
    style: { "white-space": "pre-line" }
};
const _hoisted_16 = {
    key: 0,
    class: "err"
};
const _hoisted_17 = {
    for: "01-A",
    class: "checkbox01 check_box"
};
const _hoisted_18 = {
    for: "02-A",
    class: "checkbox01 check_box"
};
const _hoisted_19 = {
    for: "03-A",
    class: "checkbox01 check_box"
};
const _hoisted_20 = {
    for: "04-A",
    class: "checkbox01 check_box"
};
const _hoisted_21 = {
    for: "05-A",
    class: "checkbox01 check_box"
};
const _hoisted_22 = { class: "form-content-raw" };
const _hoisted_23 = {
    for: "06-A",
    class: "checkbox01 check_box"
};
const _hoisted_24 = {
    key: 0,
    class: "err"
};
const _hoisted_25 = {
    key: 1,
    class: "err"
};
const _hoisted_26 = { class: "bt_box" };
const _hoisted_27 = {
    key: 0,
    class: "err_list"
};
const _hoisted_28 = {
    id: "modal_del_1",
    class: "modal min js-modal"
};
const _hoisted_29 = { class: "modal-content" };
const _hoisted_30 = { class: "close_bt bt_modal_close" };
import { ref, reactive, watch, onMounted, onUnmounted, nextTick } from 'vue';
import axios from 'axios';
import { Inertia } from '@inertiajs/inertia';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import Alert from '@util/BrowserAlert';
import PageExitConfirm from '@util/PageExitConfirm';
import InertiaUtil from '@util/InertiaUtil';
import Formatter from '@util/Formatter';
import CareerModal from '@component/Modals/CareerModal.vue';
import ImageFrame from '@component/ImageFrame.vue';
import { isObjEmpty } from '@util/Common';
export default /*@__PURE__*/ _defineComponent({
    __name: 'mentor_request_career',
    props: {
        common: {},
        errors: {},
        savedData: {}
    },
    setup(__props) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const props = __props;
        const validate = reactive({ shot: false });
        // セッションに保存されたデータがあれば復元（戻るボタン対応）
        const saved = (_a = props.savedData) !== null && _a !== void 0 ? _a : {};
        const form = InertiaUtil.getForm({
            self_introduction: (_b = saved.self_introduction) !== null && _b !== void 0 ? _b : '',
            skill_summary: (_c = saved.skill_summary) !== null && _c !== void 0 ? _c : '',
            is_public_career: (_d = saved.is_public_career) !== null && _d !== void 0 ? _d : true,
            career: (_e = saved.career) !== null && _e !== void 0 ? _e : [],
            education: (_f = saved.education) !== null && _f !== void 0 ? _f : '',
            qualification: (_g = saved.qualification) !== null && _g !== void 0 ? _g : '',
            language: (_h = saved.language) !== null && _h !== void 0 ? _h : '',
            motivation: (_j = saved.motivation) !== null && _j !== void 0 ? _j : new Array,
            other_motivation: (_k = saved.other_motivation) !== null && _k !== void 0 ? _k : '',
        }, props.common.path);
        let careerIndex = null;
        let careerDelIndex = null;
        const career = ref({
            id: null,
            started_at: '',
            is_ended: true,
            ended_at: null,
            organization: '',
            department: '',
            position: '',
            experience_content: '',
        });
        // 文字数チェック
        watch(() => form.self_introduction, (value) => {
            if (Alert.charLimitTextArea(value)) {
                form.self_introduction = value.substring(0, Alert.TEXTAREA_LIMIT_NUMBER);
            }
        });
        watch(() => form.skill_summary, (value) => {
            if (Alert.charLimitTextArea(value)) {
                form.skill_summary = value.substring(0, Alert.TEXTAREA_LIMIT_NUMBER);
            }
        });
        watch(() => form.education, (value) => {
            if (Alert.charLimitText(value)) {
                form.education = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => form.qualification, (value) => {
            if (Alert.charLimitTextArea(value)) {
                form.qualification = value.substring(0, Alert.TEXTAREA_LIMIT_NUMBER);
            }
        });
        watch(() => form.language, (value) => {
            if (Alert.charLimitTextArea(value)) {
                form.language = value.substring(0, Alert.TEXTAREA_LIMIT_NUMBER);
            }
        });
        watch(() => form.other_motivation, (value) => {
            if (Alert.charLimitText(value)) {
                form.other_motivation = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        // 編集チェック
        watch(() => form, () => PageExitConfirm.addEvent(), { deep: true });
        const onClickReturn = () => __awaiter(this, void 0, void 0, function* () {
            var _l;
            // 戻る前にセッションに保存
            const dataToSave = {
                self_introduction: form.self_introduction,
                skill_summary: form.skill_summary,
                is_public_career: form.is_public_career,
                career: form.career,
                education: form.education,
                qualification: form.qualification,
                language: form.language,
                motivation: form.motivation,
                other_motivation: form.other_motivation,
            };
            try {
                const response = yield axios.post(route('mentor.register.save_bio'), dataToSave);
                // エラーインターセプターがエラーを解決として返すため、ステータスを確認
                if (((_l = response === null || response === void 0 ? void 0 : response.response) === null || _l === void 0 ? void 0 : _l.status) && response.response.status !== 200) {
                    console.error('Failed to save bio data:', response);
                    return;
                }
            }
            catch (e) {
                console.error('Failed to save bio data:', e);
                return;
            }
            PageExitConfirm.removeEvent();
            // Inertiaで遷移（サーバーから最新データを取得）
            Inertia.visit(route('mentor.register.basic'));
        });
        const onSubmit = () => {
            PageExitConfirm.removeEvent();
            InertiaUtil.post(form, route('mentor.register.verify_bio'), () => { validate.shot = true; });
        };
        // 職歴削除モーダルの表示イベント
        const onOpenCareerDelModal = (index) => {
            careerDelIndex = index;
        };
        // 職歴削除
        const onDeleteCareer = () => {
            if (null !== careerDelIndex) {
                form.career.splice(careerDelIndex, 1);
            }
        };
        // 職歴モーダルの表示イベント
        const onOpenCareerModal = (value, index) => {
            if (value && index !== undefined) {
                careerIndex = index;
                career.value = value;
                career.value.started_at = Formatter.formatDate(career.value.started_at, 'YYYY/MM');
                let endedAt = Formatter.formatDate(career.value.ended_at, 'YYYY/MM');
                career.value.ended_at = endedAt;
                career.value.is_ended = endedAt.trim() == '';
            }
            else {
                careerIndex = null;
                career.value = {
                    id: null,
                    started_at: '',
                    is_ended: true,
                    ended_at: null,
                    organization: '',
                    department: '',
                    position: '',
                    experience_content: '',
                };
            }
        };
        // 職歴モーダルの入力が完了した時のイベント
        const onInputCareerModal = (value) => {
            const data = reactive(Object.assign({}, value));
            if (null !== careerIndex) {
                form.career[careerIndex] = data;
            }
            else {
                form.career.push(data);
                nextTick(() => {
                    // 職歴を追加した際に編集・削除ボタンのモーダルイベントを設定し直す。
                    var key = require.resolve('@jquery/modal-jquery');
                    if (key)
                        delete require.cache[key];
                    require('@jquery/modal-jquery');
                });
            }
        };
        const workPeriod = (startedAt, endedAt) => {
            return Formatter.formatCareerPeriod(startedAt, endedAt);
        };
        onMounted(() => {
            validate.shot = isObjEmpty(props.errors);
            nextTick(() => {
                var key = require.resolve('@jquery/datepicker-jquery');
                if (key)
                    delete require.cache[key];
                require('@jquery/datepicker-jquery');
                // 既に読み込まれていたら一旦削除して、読み込み直す。
                var key = require.resolve('@jquery/modal-jquery');
                if (key)
                    delete require.cache[key];
                require('@jquery/modal-jquery');
            });
        });
        onUnmounted(() => {
            PageExitConfirm.removeEvent();
        });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e;
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _cache[43] || (_cache[43] = _createElementVNode("iframe", {
                    style: { "display": "none" },
                    onload: "resizeTextarea(1,7),resizeTextarea(2,7),resizeTextarea(3,7),resizeTextarea(4,7),resizeTextarea(5,7)"
                }, null, -1)),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _cache[39] || (_cache[39] = _createElementVNode("h2", null, "メンター申請（経歴入力）", -1)),
                            _createElementVNode("div", _hoisted_4, [
                                _cache[38] || (_cache[38] = _createStaticVNode("<ul class=\"step_4\"><li class=\"off2\">基本入力</li><li class=\"active\">経歴入力<i class=\"fas fa-caret-up step-triangle\"></i></li><li class=\"off\">審査問い</li><li class=\"off\">完了</li></ul>", 1)),
                                _createElementVNode("form", {
                                    onSubmit: _withModifiers(onSubmit, ["prevent"])
                                }, [
                                    _createElementVNode("dl", null, [
                                        _cache[30] || (_cache[30] = _createElementVNode("dt", { class: "must" }, [
                                            _createTextVNode(" 自己紹介"),
                                            _createElementVNode("br", { class: "pc" }),
                                            _createElementVNode("span", { class: "must" }, "必須"),
                                            _createElementVNode("span", { class: "public" }, "公開")
                                        ], -1)),
                                        _createElementVNode("dd", null, [
                                            _withDirectives(_createElementVNode("textarea", {
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(form).self_introduction) = $event)),
                                                placeholder: "入力してください",
                                                id: "textarea_1",
                                                oninput: "resizeTextarea(1,7)"
                                            }, null, 512), [
                                                [_vModelText, _unref(form).self_introduction]
                                            ]),
                                            (validate.shot && ((_a = props.errors) === null || _a === void 0 ? void 0 : _a.self_introduction))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(props.errors.self_introduction), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _cache[31] || (_cache[31] = _createElementVNode("dt", { class: "must" }, [
                                            _createTextVNode(" スキル要約"),
                                            _createElementVNode("br", { class: "pc" }),
                                            _createElementVNode("span", { class: "must" }, "必須"),
                                            _createElementVNode("span", { class: "public" }, "公開")
                                        ], -1)),
                                        _createElementVNode("dd", null, [
                                            _withDirectives(_createElementVNode("textarea", {
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(form).skill_summary) = $event)),
                                                placeholder: "入力してください",
                                                id: "textarea_2",
                                                oninput: "resizeTextarea(2,7)"
                                            }, null, 512), [
                                                [_vModelText, _unref(form).skill_summary]
                                            ]),
                                            _cache[15] || (_cache[15] = _createElementVNode("span", null, "例：コールセンター構築・保守の経験と知見", -1)),
                                            (validate.shot && ((_b = props.errors) === null || _b === void 0 ? void 0 : _b.skill_summary))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(props.errors.skill_summary), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _cache[32] || (_cache[32] = _createElementVNode("dt", { class: "must" }, [
                                            _createTextVNode("職歴"),
                                            _createElementVNode("br", { class: "pc" }),
                                            _createElementVNode("span", { class: "must" }, "必須")
                                        ], -1)),
                                        _createElementVNode("dd", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(form).is_public_career) = $event)),
                                                value: true,
                                                class: "visually-hidden",
                                                type: "radio",
                                                name: "q1",
                                                id: "q1_a1"
                                            }, null, 512), [
                                                [_vModelRadio, _unref(form).is_public_career]
                                            ]),
                                            _cache[21] || (_cache[21] = _createElementVNode("label", { for: "q1_a1" }, "公開", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(form).is_public_career) = $event)),
                                                value: false,
                                                class: "visually-hidden",
                                                type: "radio",
                                                name: "q1",
                                                id: "q1_a2"
                                            }, null, 512), [
                                                [_vModelRadio, _unref(form).is_public_career]
                                            ]),
                                            _cache[22] || (_cache[22] = _createElementVNode("label", { for: "q1_a2" }, "非公開", -1)),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(form).career, (value, index) => {
                                                return (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                                    _createElementVNode("div", _hoisted_8, [
                                                        _createElementVNode("a", {
                                                            class: "bt_change modal_win",
                                                            "data-target": "modal_del_1",
                                                            onClick: _withModifiers(($event) => (onOpenCareerDelModal(index)), ["prevent"])
                                                        }, "削除", 8, _hoisted_9),
                                                        _createElementVNode("a", {
                                                            class: "bt_change modal_win",
                                                            "data-target": "career-modal",
                                                            onClick: _withModifiers(($event) => (onOpenCareerModal(value, index)), ["prevent"])
                                                        }, "変更", 8, _hoisted_10)
                                                    ]),
                                                    _createElementVNode("ul", null, [
                                                        _createElementVNode("li", _hoisted_11, [
                                                            _cache[16] || (_cache[16] = _createElementVNode("p", { class: "sub_t" }, "期間", -1)),
                                                            _createTextVNode(" " + _toDisplayString(workPeriod(value.started_at, value.ended_at)), 1)
                                                        ]),
                                                        _createElementVNode("li", _hoisted_12, [
                                                            _cache[17] || (_cache[17] = _createElementVNode("p", { class: "sub_t" }, "組織", -1)),
                                                            _createTextVNode(" " + _toDisplayString(value.organization), 1)
                                                        ]),
                                                        _createElementVNode("li", _hoisted_13, [
                                                            _cache[18] || (_cache[18] = _createElementVNode("p", { class: "sub_t" }, "部署", -1)),
                                                            _createTextVNode(" " + _toDisplayString(value.department), 1)
                                                        ]),
                                                        _createElementVNode("li", _hoisted_14, [
                                                            _cache[19] || (_cache[19] = _createElementVNode("p", { class: "sub_t" }, "役職", -1)),
                                                            _createTextVNode(" " + _toDisplayString(value.position), 1)
                                                        ]),
                                                        _createElementVNode("li", _hoisted_15, [
                                                            _cache[20] || (_cache[20] = _createElementVNode("p", { class: "sub_t" }, "経験内容", -1)),
                                                            _createTextVNode(" " + _toDisplayString(value.experience_content), 1)
                                                        ])
                                                    ])
                                                ]));
                                            }), 256)),
                                            (validate.shot && ((_c = props.errors) === null || _c === void 0 ? void 0 : _c.career))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(props.errors.career), 1))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("a", {
                                                class: "bt_change modal_win",
                                                "data-target": "career-modal",
                                                onClick: _cache[4] || (_cache[4] = _withModifiers(($event) => (onOpenCareerModal()), ["prevent"]))
                                            }, "追加")
                                        ]),
                                        _cache[33] || (_cache[33] = _createElementVNode("dt", { class: "must" }, [
                                            _createTextVNode(" 最終学歴"),
                                            _createElementVNode("br", { class: "pc" }),
                                            _createElementVNode("span", { class: "optionally" }, "任意"),
                                            _createElementVNode("span", { class: "public" }, "公開")
                                        ], -1)),
                                        _createElementVNode("dd", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(form).education) = $event)),
                                                type: "text",
                                                name: "q2",
                                                class: "wmax inquiry-form",
                                                placeholder: "例：○○大学□□学部"
                                            }, null, 512), [
                                                [_vModelText, _unref(form).education]
                                            ])
                                        ]),
                                        _cache[34] || (_cache[34] = _createElementVNode("dt", { class: "must" }, [
                                            _createTextVNode(" 資格"),
                                            _createElementVNode("br", { class: "pc" }),
                                            _createElementVNode("span", { class: "optionally" }, "任意"),
                                            _createElementVNode("span", { class: "public" }, "公開")
                                        ], -1)),
                                        _createElementVNode("dd", null, [
                                            _withDirectives(_createElementVNode("textarea", {
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(form).qualification) = $event)),
                                                placeholder: "例：第二種情報処理技術者",
                                                id: "textarea_4",
                                                oninput: "resizeTextarea(4,7)"
                                            }, null, 512), [
                                                [_vModelText, _unref(form).qualification]
                                            ])
                                        ]),
                                        _cache[35] || (_cache[35] = _createElementVNode("dt", { class: "must" }, [
                                            _createTextVNode(" 語学"),
                                            _createElementVNode("br", { class: "pc" }),
                                            _createElementVNode("span", { class: "optionally" }, "任意"),
                                            _createElementVNode("span", { class: "public" }, "公開")
                                        ], -1)),
                                        _createElementVNode("dd", null, [
                                            _withDirectives(_createElementVNode("textarea", {
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(form).language) = $event)),
                                                placeholder: "例：TOEIC 700点",
                                                id: "textarea_5",
                                                oninput: "resizeTextarea(5,7)"
                                            }, null, 512), [
                                                [_vModelText, _unref(form).language]
                                            ])
                                        ]),
                                        _cache[36] || (_cache[36] = _createElementVNode("dt", { class: "must" }, [
                                            _createTextVNode(" 応募動機"),
                                            _createElementVNode("br", { class: "pc" }),
                                            _createElementVNode("span", { class: "must" }, "必須"),
                                            _createElementVNode("span", { class: "non_public" }, "非公開")
                                        ], -1)),
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("label", _hoisted_17, [
                                                _withDirectives(_createElementVNode("input", {
                                                    value: "1",
                                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_unref(form).motivation) = $event)),
                                                    type: "checkbox",
                                                    id: "01-A",
                                                    name: "checkbox01"
                                                }, null, 512), [
                                                    [_vModelCheckbox, _unref(form).motivation]
                                                ]),
                                                _cache[23] || (_cache[23] = _createElementVNode("p", { class: "check_inner" }, "収入アップ", -1))
                                            ]),
                                            _createElementVNode("label", _hoisted_18, [
                                                _withDirectives(_createElementVNode("input", {
                                                    value: "2",
                                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_unref(form).motivation) = $event)),
                                                    type: "checkbox",
                                                    id: "02-A",
                                                    name: "checkbox01"
                                                }, null, 512), [
                                                    [_vModelCheckbox, _unref(form).motivation]
                                                ]),
                                                _cache[24] || (_cache[24] = _createElementVNode("span", { class: "check_inner" }, "スキルアップ", -1))
                                            ]),
                                            _createElementVNode("label", _hoisted_19, [
                                                _withDirectives(_createElementVNode("input", {
                                                    value: "3",
                                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_unref(form).motivation) = $event)),
                                                    type: "checkbox",
                                                    id: "03-A",
                                                    name: "checkbox01"
                                                }, null, 512), [
                                                    [_vModelCheckbox, _unref(form).motivation]
                                                ]),
                                                _cache[25] || (_cache[25] = _createElementVNode("span", { class: "check_inner" }, "社会貢献", -1))
                                            ]),
                                            _createElementVNode("label", _hoisted_20, [
                                                _withDirectives(_createElementVNode("input", {
                                                    value: "4",
                                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_unref(form).motivation) = $event)),
                                                    type: "checkbox",
                                                    id: "04-A",
                                                    name: "checkbox01"
                                                }, null, 512), [
                                                    [_vModelCheckbox, _unref(form).motivation]
                                                ]),
                                                _cache[26] || (_cache[26] = _createElementVNode("span", { class: "check_inner" }, "セルフブランディング", -1))
                                            ]),
                                            _createElementVNode("label", _hoisted_21, [
                                                _withDirectives(_createElementVNode("input", {
                                                    value: "5",
                                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_unref(form).motivation) = $event)),
                                                    type: "checkbox",
                                                    id: "05-A",
                                                    name: "checkbox01"
                                                }, null, 512), [
                                                    [_vModelCheckbox, _unref(form).motivation]
                                                ]),
                                                _cache[27] || (_cache[27] = _createElementVNode("span", { class: "check_inner" }, "顧客開拓", -1))
                                            ]),
                                            _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1)),
                                            _createElementVNode("div", _hoisted_22, [
                                                _createElementVNode("label", _hoisted_23, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        value: "9999",
                                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_unref(form).motivation) = $event)),
                                                        type: "checkbox",
                                                        id: "06-A",
                                                        name: "checkbox01"
                                                    }, null, 512), [
                                                        [_vModelCheckbox, _unref(form).motivation]
                                                    ]),
                                                    _cache[28] || (_cache[28] = _createElementVNode("span", { class: "check_inner" }, "その他", -1))
                                                ]),
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_unref(form).other_motivation) = $event)),
                                                    class: "wmax",
                                                    type: "text",
                                                    placeholder: "理由"
                                                }, null, 512), [
                                                    [_vModelText, _unref(form).other_motivation]
                                                ])
                                            ]),
                                            (validate.shot && ((_d = props.errors) === null || _d === void 0 ? void 0 : _d.motivation))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(props.errors.motivation), 1))
                                                : _createCommentVNode("", true),
                                            (validate.shot && ((_e = props.errors) === null || _e === void 0 ? void 0 : _e.other_motivation))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(props.errors.other_motivation), 1))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_26, [
                                        (validate.shot)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.errors, (error) => {
                                                    return (_openBlock(), _createElementBlock("p", null, _toDisplayString(error), 1));
                                                }), 256))
                                            ]))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("ul", null, [
                                            _createElementVNode("li", null, [
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    id: "submit-button",
                                                    class: "bt_back",
                                                    onClick: onClickReturn,
                                                    value: "戻る"
                                                }, " 戻る ")
                                            ]),
                                            _cache[37] || (_cache[37] = _createElementVNode("li", null, [
                                                _createElementVNode("button", {
                                                    type: "submit",
                                                    id: "submit-button",
                                                    class: "bt_next",
                                                    value: "次へ"
                                                }, " 次へ ")
                                            ], -1))
                                        ])
                                    ])
                                ], 32)
                            ])
                        ])
                    ]),
                    _createElementVNode("form", null, [
                        _createVNode(CareerModal, {
                            form: career.value,
                            onInput: onInputCareerModal
                        }, null, 8, ["form"]),
                        _createElementVNode("div", _hoisted_28, [
                            _cache[42] || (_cache[42] = _createElementVNode("div", { class: "modal-bg bt_modal_close" }, null, -1)),
                            _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("div", _hoisted_30, [
                                    _createVNode(ImageFrame, { src: "images/common/i_bt_close.svg" })
                                ]),
                                _createElementVNode("div", { class: "pop" }, [
                                    _cache[41] || (_cache[41] = _createElementVNode("h2", null, "削除してもよろしいですか？", -1)),
                                    _createElementVNode("div", { class: "bt_box clear" }, [
                                        _createElementVNode("ul", { class: "modalBtn-area b2" }, [
                                            _cache[40] || (_cache[40] = _createElementVNode("li", null, [
                                                _createElementVNode("p", { class: "bt_modal_close bt_clear" }, "キャンセル")
                                            ], -1)),
                                            _createElementVNode("li", null, [
                                                _createElementVNode("p", {
                                                    class: "bt_modal_close bt_ok",
                                                    onClick: onDeleteCareer
                                                }, "OK")
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
